import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Tab,
  Tabs,
} from "@mui/material";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { setStorePermissions } from "../redux/store/storeSlice";
import { ServiceApi } from "../services/index.service";
import AWS from "aws-sdk";
import FlavorTabShimmer from "./FlavorTabShimmer";
import PreSellBoardsList from "./PreSellBoardsList";
import Snapshot from "./Snapshot";
import { DTB_TOUR_STEPS } from "../utils/tourConstants";
import { continuousTour, runTour, showTourProgress, updateSteps } from "../redux/userOnboarding/userOnboardingSlice";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DriveThru = () => {
  const [value, setValue] = useState(0);
  const [store, setStore] = useState(null);
  const [permissionLoading, setPemissionLoading] = useState(false);
  const serviceapi = new ServiceApi();
  const dispatch = useDispatch();
  const data = useSelector((state) => state);
  const { storage, userOnboarding } = useSelector((state) => state);
  const [image, setImage] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const [noimage, setNoImage] = useState("");
  const [iKey, setIKey] = useState("");
  const [imgName, setImgName] = useState("");
  const tabsList = [
    {
      id: 1,
      title: "drivethru-menuboard",
      image: "",
      label: "Menu Board",
      disabled: false,
      show: true,
      className: 'dt-menu-board-tab-tour-selector'
    },
    {
      id: 2,
      title: "drivethru-flavorboard",
      image: "",
      label: "Flavor Board",
      disabled: false,
      show: true,
      className: 'dt-flavor-board-tab-tour-selector'
    },
    {
      id: 3,
      title: "drivethru-presellboard",
      image: "",
      label: "Pre-Sell Board",
      disabled: false,
      show: storage?.permissions?.DigitalDriveThruWithPreSellBoard,
      className: 'dt-presell-board-tab-tour-selector'
    },
    {
      id: 4,
      title: "drivethru-snapshots",
      image: "",
      label: "Snapshot",
      disabled: false,
      show: true,
      className: 'dt-snapshot-tab-tour-selector'
    },
  ];

  useEffect(() => {
    if(store?.intStoreID){
      fetchStorePermissions();
    }
  }, [store]);
  

  useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);

  //Tour Hook 
  useEffect( () => {
    if (!userOnboarding?.tourStatus?.digitalDriveThruBoard && store){
      const tabIndexVal = DTB_TOUR_STEPS[userOnboarding?.stepIndex]?.tabIndex;
      (tabIndexVal >= 0) && handleChange({target: {}}, tabIndexVal);
       startDigitalDriveThruBoardTour();
    }
    else handleChange({target: {}}, value);
  }, [store, userOnboarding?.tourStatus?.digitalDriveThruBoard, userOnboarding?.stepIndex])

  const startDigitalDriveThruBoardTour = () => {
    dispatch(updateSteps(DTB_TOUR_STEPS));
    dispatch(continuousTour());
    dispatch(showTourProgress());
    dispatch(runTour("digitalDriveThruBoard"));
  }


  const fetchStorePermissions = async () => {
    const req = {
      intStoreID: store?.intStoreID,
      role: data?.profile?.role,
    };
    setPemissionLoading(true)
    const res = await serviceapi.fetchStorePermissions(req);
    setPemissionLoading(false)
    dispatch(setStorePermissions(res))
  };

  useEffect(() => {
    if (data?.profile) {
      setNoImage("");
      setImgName("");
      setIKey("");
      setValue(0);
      downloadImages(storage?.store?.intRitasStoreID, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.profile]);
  const s3 = new AWS.S3();

  const downloadImages = (ritasStoreID, index = 0) => {
    setNoImage("");
    setImageLoading(true);
    if (ritasStoreID) {
      var url = s3.getSignedUrl("getObject", {
        Bucket: process.env.REACT_APP_AWS_BUCKET,
        Key: `${process.env.REACT_APP_DMB_END_POINT_IMAGES}/${!userOnboarding?.tourStatus?.digitalDriveThruBoard ? 0 : ritasStoreID}/${tabsList[index].title}-${!userOnboarding?.tourStatus?.digitalDriveThruBoard ? 0 : ritasStoreID}-1920.jpg`,
      });
      setIKey(
        `${process.env.REACT_APP_DMB_END_POINT_IMAGES}/${!userOnboarding?.tourStatus?.digitalDriveThruBoard ? 0 : ritasStoreID}/${tabsList[index].title}-${ritasStoreID}-1920.jpg`
      );
      // console.log(url, "donwload url");
      if (url) {
        setImage(url);
        setImgName(tabsList[index].title);
        setTimeout(() => setImageLoading(false), 399);
      }
    }
  };
  const handleFullScreen = () => {
    let urlObject = new URL(image);
    urlObject.searchParams.delete('rand');
    const modifiedUrl = urlObject.toString();
    window.open(modifiedUrl, "_blank");
  };

  const handleChange = (event, newValue) => {
    // console.log(event, "event");
    setValue(newValue);
    setImgName(event.target.textContent);
    setImage("");
    downloadImages(storage?.store?.intRitasStoreID, newValue);
  };

  const download = (url) => {
    let s3 = new AWS.S3({ params: { Bucket: process.env.REACT_APP_AWS_BUCKET } });
    const myArray = url.split(process.env.REACT_APP_DMB_END_POINT_IMAGES);
    console.log(myArray[1]);
    let params = {
      Bucket: process.env.REACT_APP_AWS_BUCKET,
      Key: iKey,
    };
    console.log(params);
    s3.getObject(params, (err, data) => {
      // console.log(data, "image data", url);
      let blob = new Blob([data.Body], { type: data.ContentType });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const imageOnLoad = (event) => {
    // console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
    if (event.currentTarget.className !== "error") {
      event.currentTarget.className = "success";
      setNoImage("SUCCESS");
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = "../assets/images/noimage.jpg";
    event.currentTarget.className = "error";
    setNoImage("FAILURE");
  };

  const BoardInfo = () => {
    if (imageLoading) {
      return (
        <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
          <FlavorTabShimmer />
          <FlavorTabShimmer />
          <FlavorTabShimmer />
          <FlavorTabShimmer />
          <FlavorTabShimmer />
          <FlavorTabShimmer />
        </div>
      );
    } else {
      return (
        <Card justify="center" alignItems="center">
          <img
            src={image}
            onLoad={imageOnLoad}
            onError={imageOnError}
            style={{ minHeight: "320px", margin: "auto" }}
            alt="drive board"
          />
          {noimage !== "" && noimage === "FAILURE" && (
            <CardContent>
              <div
                style={{
                  textAlign: "center",
                }}
              >
                Menu Boards are not configured this shop. Please contact your Franchise Consultant for assistance.
              </div>
            </CardContent>
          )}
          {noimage !== "" && noimage !== "FAILURE" && (
            <CardContent
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => download(`${imgName}.jpg`)}
                className="dt-flash-drive-tour-selector"
              >
                USB Flash Drive
              </Button>
              {/* <Button
                variant="outlined"
                onClick={() => download(`${imgName}.jpg`)}
              >
                Media Version
              </Button> */}
              <Button variant="outlined" onClick={() => handleFullScreen()} className="dt-streaming-tour-selector">
                Streaming
              </Button>
            </CardContent>
          )}
          {/* <small className="m-2" style={{color:"#D41D49"}}><b>Note:</b> USB-Storage drive is deprecated.Please contact your Franchise Consultant for assistance</small> */}
        </Card>
      );
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={permissionLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col">
              <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                Digital Drive Thru Board
              </h1>
              <small className="pt-2" style={{ color: "#D41D49" }}>
                <b>Note:</b> It may take up to 1 minute for the menu board image
                to update with flavor changes.{" "}
              </small>
            </div>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 py-8">
            <div className="rounded-md bg-white shadow-md">
              <>
                {(storage?.permissions?.DigitalDriveThruBoard || storage?.permissions?.DigitalDriveThruWithPreSellBoard) && storage?.store && Object.keys(storage?.store).length ? (
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs value={value} onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        classes={{ scroller: userOnboarding?.tourStatus?.digitalDriveThruBoard ? "" : "!overflow-hidden" }}
                      >
                        {tabsList?.filter(i => i?.show)?.map((itm, index) => (
                          <Tab
                            label={itm.label}
                            {...a11yProps(itm.id)}
                            key={itm.id}
                            disabled={itm.disabled}
                            className={itm.className}
                          />
                        ))}
                      </Tabs>
                    </Box>
                    {tabsList?.filter(i => i?.show)?.map((tabItem, index) => {
                      return (
                        <TabPanel key={tabItem.id} value={value} index={index}>
                          {tabItem?.id === 3 && (
                            <PreSellBoardsList store={store} />
                          )}
                          {tabItem?.id === 4 && <Snapshot store={store} tourEnabled={!userOnboarding?.tourStatus?.digitalDriveThruBoard} />}
                          {(tabItem?.id === 1 || tabItem?.id === 2) &&
                            BoardInfo()}
                        </TabPanel>
                      );
                    })}
                  </Box>
                ) : (<>
                  {!store ? <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                    Please select a store
                  </div> : <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                    Drive Thru is not configured for selected Store
                  </div>}
                </>
                )}
              </>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default DriveThru;